import {
  Component,
  OnInit,
  Input,
  ViewContainerRef,
  ViewEncapsulation
} from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs/Subscription';
import { Router, ActivatedRoute, ParamMap, Params, NavigationStart, NavigationEnd } from '@angular/router';

import { RequestsServices } from '../../../services/requests.service';
import { UserService } from '../../../services/user.service';
import { StorageService } from '../../../services/storage.service';
import { PageBase } from '../../../page.base';
import { ToasterService } from '../../../services/toaster.service';
import { TranslateService } from '@ngx-translate/core';
import { HeaderMenuComponent } from '../../../components/header-menu/header-menu.component';
import { CEPServices } from '../../../services/cep.service';
import { AddressService } from '../../../services/address.service';


@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  providers: [ RequestsServices, StorageService, UserService, CEPServices, AddressService ],
  encapsulation: ViewEncapsulation.None
})

export class AddressesComponent extends PageBase implements OnInit {

  public establishment = {
    addresses: [],
  };
  private addressErros = [];
  private isShowError = false;

  public isLoading;

  constructor(private translate: TranslateService,
    private toaster: ToasterService,
    private request: RequestsServices,
    private route: ActivatedRoute,
    private router: Router,
    private storage: StorageService,
    private userService: UserService,
    public _cepService: CEPServices,
    public addressService: AddressService) {

    super();

    let languageCurrent = navigator.language;
    translate.addLangs(['en', 'pt-br']);
    translate.setDefaultLang('en');
    languageCurrent === 'pt-BR' ? translate.use('pt-br') : translate.use('en');
  }

  public ngOnInit(): void {
    window.scrollTo(0, 0);

    const establishmentAccount = this.userService.getLoggedAccount();
    const typeBusiness = this.userService.getTypeAccount();
    if (typeBusiness === 'establishment' && establishmentAccount) {
      this.getEstablishment(establishmentAccount['id']);
    } else {
      this.toaster.error('Aviso!', 'Conta de negócio inválida', false, 4000);
      this.router.navigate(['/home']);
    }
  }

  private addressToGeopoint(address, index): any {
    let addressAsString = '';
    if (address.street) {
      addressAsString += address.street;
    }

    if (address.number) {
      addressAsString += ', ' + address.number;
    }

    if (address.neighborhood) {
      addressAsString += ', ' + address.neighborhood;
    }

    if (address.county) {
      addressAsString += ', ' + address.county;
    }

    if (address.state) {
      addressAsString += ', ' + address.state;
    }

    if (address.cep) {
      addressAsString += ', ' + address.cep;
    }

    const requestGeopoint = this.addressService.addressToGeoPoint(addressAsString);

    return requestGeopoint;
  }

  private transformFildsNamesFromApi(): void {
    this.establishment['addresses'] = this.establishment['addresses'].map((address) => {
      address.num_employees = [1];
      return address;
    });
  }

  private transformFildsNamesToApi(): Object {
    const establishmentData = Object.assign({}, this.establishment);
    establishmentData['addresses'] = establishmentData['addresses'].map((address) => {
      const addressData = Object.assign({}, address);

      addressData.establishmentId = this.establishment['id'];

      delete addressData.num_employees;
      delete addressData.isOpenAccordion;
      delete addressData.index;

      return addressData;
    });

    return establishmentData;
  }

  private getEstablishment(establishmentId): void {
    this.isLoading = true;
    this.request.get({path: 'establishments', pathParam: `/${establishmentId}?filter[include]=addresses`}).then((establishment) => {
      this.isLoading = false;
      this.establishment = establishment;
      this.transformFildsNamesFromApi();
    });
  }

  public cepChange(value: any, index: number): void {
    let getCep = value.currentTarget.value;
    if (!getCep) {
      return;
    }

    getCep = getCep.replace(/_/g, '');

    if (getCep.length === 9) {
      this.isLoading = true;
      this._cepService.getAddressByCep(getCep).subscribe((place) => {
        this.isLoading = false;

        this.establishment['addresses'][index].neighborhood = place.bairro;
        this.establishment['addresses'][index].county = place.localidade;
        this.establishment['addresses'][index].state = place.uf;
        this.establishment['addresses'][index].street = place.logradouro;
        this.addressErros = this.checkAddressErros(this.establishment['addresses']);
      });
    }
  }

  public showErros(): void {
    this.isShowError = true;
    this.addressErros = this.checkAddressErros(this.establishment['addresses']);
  }

  public addAddress(): void {
    this.isShowError = false;
    this.addressErros = this.checkAddressErros(this.establishment['addresses']);

    const lastAddress =  this.establishment['addresses'][this.establishment['addresses'].length - 1];
    if (!this.validateAddress(this.establishment['addresses'], false)) {
      this.isShowError = true;
      return;
    }

    // Closse all others accordions addresses
    for (let address of this.establishment['addresses']) {
      address.isOpenAccordion = false;
    }

    let calcLength = this.establishment['addresses'].length + 1;
    this.establishment['addresses'].push({
      index: calcLength - 1,
      isOpenAccordion: true,
      name: 'Endereço ' + calcLength,
      nameUnit: null,
      cep: null,
      neighborhood: null,
      county: null,
      state: null,
      street: null,
      number: null,
      additional: null,
      telephone: null,
      location: {lat: 0, lng: 0}
    });
  }

  private removeAddress(index: number): void {

    const addressId = this.establishment['addresses'][index]['id'] || null;

    if (addressId) {
      // Delete request
      this.isLoading = true;
      this.request.delete('establishment_addresses', '', `/${addressId}`).then((establishment) => {
        this.isLoading = false;

        this.getEstablishment(this.establishment['id']);

        this.toaster.info('Sucesso', 'Endereço atualizado com sucesso.', true, 2000);
        this.userService.requestAccountConfig();
      });
    } else {
      this.establishment['addresses'].splice(index, 1);
    }

  }

  private updateAddressErros(): void {
    this.addressErros = this.checkAddressErros(this.establishment['addresses']);
  }

  public updateAddress(i): void {
    this.addressErros = this.checkAddressErros(this.establishment['addresses']);

    if (!this.validateAddress(this.establishment.addresses, false, 0)) {
      this.toaster.info('Atenção', 'Preencha pelo menos 1 endereço.', false, 4000);
      this.showErros();
      return;
    } else {

      if (!this.validateAddress(this.establishment['addresses'], false)) {
        this.isShowError = true;
        return;
      }

      const establishmentData = this.transformFildsNamesToApi();
      let addressesData = establishmentData['addresses'][i];

      this.isLoading = true;
      this.addressToGeopoint(addressesData, i).then((geolocation) => {
        this.isLoading = false;
        if (geolocation && geolocation.lat && geolocation.lng) {
          addressesData = {...addressesData, location: {lat: geolocation.lat, lng: geolocation.lng}};
        } else {
          addressesData = {...addressesData, location: {lat: 0, lng: 0}};
        }
        this.saveRequest(addressesData);
      });

    }

  }

  private saveRequest(addressesData): void {
    if (addressesData && addressesData['id']) {
      this.isLoading = true;
      this.request.put('establishment_addresses', addressesData).then((establishment) => {
        this.isLoading = false;
        if (establishment) {
          this.getEstablishment(this.establishment['id']);
          this.toaster.info('Sucesso', 'Endereço salvo com sucesso.', true, 2000);
          this.userService.requestAccountConfig();
        }
      });
    } else {
      this.isLoading = true;
      this.request.post('establishment_addresses', addressesData).then((establishment) => {
        this.isLoading = false;
        if (establishment) {
          this.getEstablishment(this.establishment['id']);
          this.toaster.info('Sucesso', 'Endereço salvo com sucesso.', true, 2000);
          this.userService.requestAccountConfig();
        }
      });
    }
  }

}
